import { z } from 'zod';
import { ObjectIdSchema } from '../../../../shared/object-id.schema';
import { BaseErrorSchema } from '../../../../shared/error.schema';
import { TenantCloneCleanupStatusSchema } from '../list-clone-jobs/list-clone-jobs.schema';
/**
 * Discard Clone Job Request Schema
 * POST /api/v2/tenant-clone-jobs/:jobId/discard
 *
 * Path param only — the job is the entire input. Everything the rollback needs
 * (which tenant, which source, the ownership nonce) is read from the job
 * document, never taken from the caller: the destructive step is a
 * `dropDatabase`, and a client-supplied target is not something to trust.
 */ export const DiscardCloneJobRequestSchema = z.object({
    jobId: ObjectIdSchema
});
/**
 * Discard Clone Job Response Schema
 *
 * Returns the cleanup record rather than a bare `success`, because "the discard
 * ran" and "everything was undone" are different facts. The discard is
 * synchronous, so the caller learns about a partial rollback immediately
 * instead of inferring it from the next poll.
 *
 * `jobRetained` is true when the job document was kept so the leftovers stay
 * visible in `GET /api/v2/tenant-clone-jobs`; a fully successful discard
 * deletes the job and returns false.
 */ export const DiscardCloneJobResponseSchema = z.object({
    cleanupStatus: TenantCloneCleanupStatusSchema,
    jobRetained: z.boolean()
});
/**
 * Discard Clone Job Error Schema
 * Refusals carry `ErrorCode.TENANT_CLONE_DISCARD_REFUSED`; nothing was dropped.
 */ export const DiscardCloneJobErrorSchema = BaseErrorSchema;

//# sourceMappingURL=discard-clone-job.schema.js.map